export default "__VITE_ASSET__DucqnlZQ__"